export const isCurrentScheduleShareMetaRequest = (
    institutionUrlSegment,
    endpointPath,
    method = 'GET'
) => {
    if (String(method).toUpperCase() !== 'GET') return false;

    const contextMatch = typeof institutionUrlSegment === 'string'
        ? institutionUrlSegment.match(/\/schedule-shares\/([^/]+)$/)
        : null;
    const endpointMatch = typeof endpointPath === 'string'
        ? endpointPath.match(/^\/schedule-shares\/([^/]+)$/)
        : null;

    return !!(
        contextMatch
        && endpointMatch
        && contextMatch[1] === endpointMatch[1]
    );
};
